import React from 'react';
import { UseFormRegister, UseFormWatch } from 'react-hook-form';
import { InvoiceHire } from '../../types';

interface InvoiceHireDebitNoteContentProps {
  register: UseFormRegister<InvoiceHire>;
  watch: UseFormWatch<InvoiceHire>;
  isDebitNote: boolean;
  clients: any[];
}

const InvoiceHireDebitNoteContent: React.FC<InvoiceHireDebitNoteContentProps> = ({
  register,
  watch,
  isDebitNote,
  clients,
}) => {
  const handlePrint = () => {
    const content = watch('freeTextContent') || '';
    const invoiceNum = watch('invoiceNumber') || '';
    const invoiceDate = watch('invoiceDate') || '';
    const customerName = (() => {
      const cId = watch('customerId');
      const c = clients.find((cl: any) => (cl.documentId || cl.id) === cId);
      return c ? (c as any).name : '';
    })();
    const printWindow = window.open('', '_blank');
    if (printWindow) {
      printWindow.document.write(`
        <html>
          <head>
            <title>${isDebitNote ? 'Debit Note' : 'Credit Note'} - ${invoiceNum}</title>
            <style>
              body { font-family: Arial, sans-serif; padding: 40px; color: #333; }
              .header { text-align: center; margin-bottom: 30px; border-bottom: 2px solid #333; padding-bottom: 20px; }
              .header h1 { font-size: 18px; margin: 0; }
              .header h2 { font-size: 24px; margin: 10px 0; color: #1a1a1a; }
              .meta { display: flex; justify-content: space-between; margin-bottom: 20px; font-size: 14px; }
              .content { white-space: pre-wrap; font-size: 14px; line-height: 1.8; border: 1px solid #ddd; padding: 20px; min-height: 200px; }
              .footer { margin-top: 40px; display: flex; justify-content: space-between; }
              .signature { text-align: center; width: 200px; }
              .signature .line { border-top: 1px solid #333; margin-top: 60px; padding-top: 5px; }
              @media print { body { padding: 20px; } }
            </style>
          </head>
          <body>
            <div class="header">
              <h1>Petromarine Offshore Projects Support Co.</h1>
              <h2>${isDebitNote ? 'DEBIT NOTE' : 'CREDIT NOTE'}</h2>
            </div>
            <div class="meta">
              <div><strong>No:</strong> ${invoiceNum}</div>
              <div><strong>Date:</strong> ${invoiceDate}</div>
              <div><strong>Customer:</strong> ${customerName}</div>
            </div>
            <div class="content">${content}</div>
            <div class="footer">
              <div class="signature">
                <div class="line">Finance Dep.</div>
              </div>
              <div class="signature">
                <div class="line">General Manager</div>
              </div>
            </div>
          </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.print();
    }
  };

  return (
    <div className="card">
      <div className="card-header">
        <div className="flex justify-between items-center">
          <h2 className="text-lg font-semibold text-gray-900">
            {isDebitNote ? 'Debit Note Content' : 'Credit Note Content'}
          </h2>
          <button
            type="button"
            onClick={handlePrint}
            className="px-4 py-2 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 flex items-center space-x-2"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
            </svg>
            <span>Print</span>
          </button>
        </div>
      </div>
      <div className="card-body">
        <textarea
          {...register('freeTextContent')}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 font-mono"
          rows={8}
          placeholder={`Enter ${isDebitNote ? 'debit' : 'credit'} note content here. This text will be printed on the document...`}
        />
      </div>
    </div>
  );
};

export default InvoiceHireDebitNoteContent;
